import axios from 'axios';
import { loadConfig, getConfig } from '../config';

if (getConfig('BACKEND_URL') === undefined) {
    await loadConfig();
}

const api = axios.create({
    baseURL: getConfig('BACKEND_URL'),
});

api.interceptors.request.use((config) => {
    config.headers['x-api-key'] = 'FKD5hDEUyqA4Zr8FqIRVJNWRmcMNfDkkxBJFI8CD1ngMtynH1PWM6ubH4AK5QavR';
    config.headers['Content-Type'] = 'application/json';
    return config;
});

export default api;